//NOTE:  3/14/2024 This used to be for creatng teams in a league
//It's been repurposed to create divisions within a tournament (mens a, mens b, coed, etc)
import React, { useState } from 'react'
import Modal from '../../shared/components/UIElements/Modal'
import AdminNavigation from './AdminNavigation'
import './../../teams/pages/TeamForm.css'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import { useNavigate, useParams } from 'react-router-dom'

const AdminUploadTeam = () => {
	console.log('inside AdminUploadTeam')

	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [pastedTeam, setPastedTeam] = useState()
	const [unfounds, setUnfounds] = useState([])
	const [showConflictModal, setShowConflictModal] = useState(false)
	const [showTryAgainModal, setShowTryAgainModal] = useState(false)
	const [cancelHasBeenClicked, setCancelHasBeenClicked] = useState()
	const leagueName = useParams().leagueName
	const divisionId = useParams().divisionId
	const teamName = useParams().teamName
	const year = useParams().year
	const teamId = useParams().teamId

	console.log('teamId: ' + teamId)

	let navigate = useNavigate()

	const errorHandler = () => {
		setError(null)
	}

	const getPastedTeam = (event) => {
		const team = event.target.value
		console.log('team: ' + team)
		setPastedTeam(team)
	}

	const submitTeam = async (event) => {
		//console.log('submitTeam: ' + pastedTeam)
		event.preventDefault()

		//alert('submitTeam: ' + pastedTeam)
		const split = pastedTeam.split('\n')
		//alert('split length: ' + split.length)
		const split2 = split[0].split('\t')
		//alert('split2.length: ' + split2.length)
		//
		//Right here.  If split2.length does NOT equal 3, that means that they
		// forgot to copy either the Goalie? column or the usabh column.
		// We need to throw an error in that situation, so that the system
		// doesnt go down with a "Failed to Fetch" error.
		//
		if (split2.length != 3) {
			setShowTryAgainModal(true)
		} else {
			setShowTryAgainModal(false)
		}

		if (showTryAgainModal === false && split2.length === 3) {
			try {
				setIsLoading(true)
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + `/admin/${teamId}/uploadTeam`,
					{
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({
							pastedTeam,
						}),
					},
				)
				// parse json safely (backend might send non-json on error)
				let responseData = null
				try {
					responseData = await response.json()
				} catch (e) {
					responseData = null
				}
				if (!response.ok) {
					throw new Error(responseData?.message || 'Upload failed')
				}

				const notFounds = responseData?.listOfNotFounds || []

				if (notFounds.length > 0) {
					setUnfounds(notFounds)
					setShowConflictModal(true)
				} else {
					navigate(
						`/admin/${leagueName}/${year}/${divisionId}/${teamName}/players`,
					)
				}
				setIsLoading(false)
			} catch (err) {
				setIsLoading(false)
				setError(err.message || 'Something went wrong with submitting a team')
			}
		}
	}

	let usabhDisplay
	usabhDisplay = []

	if (!isLoading && unfounds) {
		unfounds.forEach((unfound) => {
			const split = unfound.split('|')
			const goalie = split[0]
			const jerseyNumber = split[1]
			const usabhNum = split[2]

			usabhDisplay.push(usabhNum)
		})
	}

	const cancelConflictHandler = () => {
		setShowConflictModal(false)
		setCancelHasBeenClicked(true)
		navigate(`/admin/${leagueName}/${year}/${divisionId}/${teamName}/players`)
	}

	const letsAddThemHandler = () => {
		setShowConflictModal(false)
		setCancelHasBeenClicked(true)
		navigate(
			`/admin/${leagueName}/${year}/${divisionId}/${teamName}/${teamId}/newPlayerFromUnfounds`,
			{ state: { unfounds } },
		)
	}

	const tryAgainHandler = () => {
		setShowTryAgainModal(false)
	}

	const cancelTryAgainHandler = () => {
		setShowTryAgainModal(false)
	}

	return (
		<React.Fragment>
			<ErrorModal error={error} onClear={errorHandler} />
			<Modal
				show={showConflictModal}
				onCancel={cancelConflictHandler}
				header='Players Not Found!!'
				footerClass='place-item__modal-actions'
				footer={
					<React.Fragment>
						<h3>The following USABH numbers were not found in our system:</h3>
						<div style={{ marginTop: '2rem' }}>
							{usabhDisplay.map((usabhDisplay, i) => (
								<div>
									<p
										style={{
											textAlign: 'center',
											color: 'red',
											fontWeight: '800',
										}}
									>
										{usabhDisplay}
									</p>
								</div>
							))}
						</div>
						<br></br>
						<button
							className='okbutton cancelDeleteButtons'
							inverse
							//onClick={cancelConflictHandler}
							onClick={letsAddThemHandler}
						>
							Let's Add Them!
						</button>
					</React.Fragment>
				}
			></Modal>
			<Modal
				show={showTryAgainModal}
				onCancel={cancelTryAgainHandler}
				header='Uh Oh!'
				footerClass='place-item__modal-actions'
				footer={
					<React.Fragment>
						<h3>Did you forget to paste in all three columns??</h3>

						<br></br>
						<button
							className='okbutton cancelDeleteButtons'
							inverse
							//onClick={cancelConflictHandler}
							onClick={tryAgainHandler}
						>
							Try Again
						</button>
					</React.Fragment>
				}
			></Modal>
			<div>
				{isLoading && <LoadingSpinner asOverlay />}
				<AdminNavigation />
				<main>
					<h2>Upload Roster for {teamName}</h2>
					<div style={{ display: '-webkit-box' }}>
						<a
							href='https://www.youtube.com/watch?v=KBMk9cIrESU'
							target='_blank'
							rel='noreferror'
							className='uploadVid'
						>
							(Video: How to bulk-upload a Team)
						</a>
					</div>
					<form style={{ marginTop: '4rem' }}>
						<textarea
							className='uploadScreen'
							name='excel_data'
							placeholder='BEST IF DONE ON DESKTOP OR LAPTOP.  From the Excel document, copy and paste over the Goalie column, the Jersey # column and USABH # column together.'
							onChange={getPastedTeam}
						></textarea>
						<input
							type='button'
							className='uploadButton'
							onClick={(event) => submitTeam(event)}
							value='Submit'
						/>
						<br></br>
					</form>
				</main>
			</div>
		</React.Fragment>
	)
}

export default AdminUploadTeam
